const ActivitiesConstants = {
  INSURANCE_TRAINER_ID: 'dddddddd-dddd-dddd-dddd-ee5841a5b48c',
};
export default ActivitiesConstants;
